import { render, staticRenderFns } from "./InstagramSettings.vue?vue&type=template&id=4b11490a&scoped=true"
import script from "./InstagramSettings.vue?vue&type=script&lang=js"
export * from "./InstagramSettings.vue?vue&type=script&lang=js"
import style0 from "./InstagramSettings.vue?vue&type=style&index=0&id=4b11490a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b11490a",
  null
  
)

export default component.exports